import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              焦点专题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              精选四大追剧专题，发现属于你的下一部神作
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {carouselData.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-lg border border-secondary-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="relative w-full" style={{ aspectRatio: '7/4' }}>
                  <img
                    src={item.image}
                    alt={`木瓜影视${item.title}`}
                    title={`木瓜影视-${item.title}-焦点专题`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      const parent = target.parentElement;
                      if (parent) parent.style.display = 'none';
                    }}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5 flex-1 flex flex-col">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500">{item.subtitle}</p>
                  <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                    {item.description}
                  </p>
                  <div className="mt-4 pt-3 border-t border-secondary-100">
                    <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium cursor-pointer">
                      探索专题 <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}